import React from "react";
import { useTranslation } from "react-i18next";
import { useGetCartQuery } from "../../api/cartApi";
import Icon from "../../../../../common/components/Icon/Icon";

const FreeShippingProgressBar: React.FC = () => {
  const { t, ready: areTranslationsReady } = useTranslation();
  const { data: cart, isLoading } = useGetCartQuery();

  if (isLoading || !areTranslationsReady || !cart) {
    return null;
  }

  const {
    isFreeShippingAvailable,
    freeShippingRequirement,
    hasFreeShippingCoupon,
    freeShippingThreshold,
    amountNeededForFreeShipping,
    formattedAmountNeededForFreeShipping,
  } = cart;

  if (freeShippingRequirement === "not_configured") return null;
  if (freeShippingRequirement === "coupon" && !hasFreeShippingCoupon)
    return null;
  if (freeShippingRequirement === "both" && !isFreeShippingAvailable)
    return null;

  const hasReachedThreshold = isFreeShippingAvailable;

  let progressPercentage = 0;
  if (freeShippingThreshold && freeShippingThreshold > 0) {
    const subtotal = hasReachedThreshold
      ? freeShippingThreshold
      : freeShippingThreshold - (amountNeededForFreeShipping || 0);
    progressPercentage = Math.min(
      (subtotal / freeShippingThreshold) * 100,
      100,
    );
  } else if (hasReachedThreshold) {
    progressPercentage = 100;
  }

  const message = hasReachedThreshold
    ? t("freeShippingProgressBar.successMessage", "You've got free shipping!")
    : t("freeShippingProgressBar.message", {
        amount: formattedAmountNeededForFreeShipping,
        defaultValue: "Add {{amount}} more to your cart to get free shipping!",
      });

  // Updated to use the generic 'cart-progress-bar' class
  const rootClassName = `cart-progress-bar free-shipping-bar ${
    hasReachedThreshold ? "is-achieved" : ""
  }`;

  return (
    <div className={rootClassName}>
      <p className="cart-progress-bar__message">
        <Icon iconName="package-outlined" className="cart-progress-bar__icon" />
        {message}
      </p>
      <div className="cart-progress-bar__track">
        <div
          className="cart-progress-bar__fill"
          style={{ width: `${progressPercentage}%` }}
        ></div>
      </div>
    </div>
  );
};

export default FreeShippingProgressBar;
